import { EMPTY_ARRAY } from 'commons-ui';
import config from 'config';

export const GET_USER_ACTIVITY_ENDPOINT = '/crm/userDetails/userSummary/getUserSignUpAndLastActivityV2';
export const GET_USERS_HEARTBEAT_DETAILS_BULK_ENDPOINT = '/dashboard/getUsersHeartBeatDetailsBulk';
export const GET_USER_CALLING_SLOTS_ENDPOINT = '/dashboard/getUserCallingSlots';

export const VIEW_FIELD_KEYS = {
	USER_STATS_INFO: 'userStatsInfo',

	USER_ACTIVITY: 'userActivity',
	SIGN_UP: 'signUp',
	LAST_ACTIVITY: 'lastActivity',
	LA_LOGIN_TIMESTAMP: 'last_game_time',
	LA_LOCATION: 'last_login_state',
	LA_IP_ADDRESS: 'last_login_ip',

	HEARTBEAT_STATUS: 'heartbeatStatus',
	ONLINE_STATUS: 'onlineStatus',
	LAST_SEEN: 'lastSeen',

	CALLING_SLOTS: 'callingSlots',
	RECOMMENDED_CALLING_SLOTS: 'recommended_calling_slots',
	BEST_SLOT: 'best_slot',
	SECOND_BEST_SLOT: 'second_best_slot',
	THIRD_BEST_SLOT: 'third_best_slot',
	BEST_SLOT_ALL_HOURS: 'best_slot_all_hours',
	SECOND_BEST_SLOT_ALL_HOURS: 'second_best_slot_all_hours',
	THIRD_BEST_SLOT_ALL_HOURS: 'third_best_slot_all_hours',

	PORTFOLIO: 'portfolio',
	NET_PORTFOLIO: 'netPortfolio',
	TOTAL_GAMEPLAYS: 'gameplaysCount',
	TOTAL_TICKETS_RAISED: 'helpdeskTicketCount',
	TOTAL_REFERRALS: 'referralsCount',
	NUMBER_OF_DEPOSITS: 'depositCount',
	LIFETIME_DEPOSITS: 'totalDeposit',
	LIFETIME_WINNINGS: 'totalWinnings',
	LIFETIME_RAKE: 'totalRake',
	LIFETIME_GAMEPLAY_LOSSES: 'totalLoss',
	LIFETIME_DEPOSITS_PORTFOLIO: 'depositAmount',
	LIFETIME_WITHDRAWALS_PORTFOLIO: 'withdrawalAmount',
	LIFETIME_NET_PORTFOLIO: 'netPortFolio',
	...config.SIGN_UP_TRACKING_FIELDS
};

export const DEFAULT_PORTFOLIO_DATE_RANGE = EMPTY_ARRAY;
